// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlipayOutlinedSvg from "@ant-design/icons-svg/es/asn/AlipayOutlined";
import AntdIcon from '../components/AntdIcon';

var AlipayOutlined = function AlipayOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlipayOutlinedSvg
  }));
};

AlipayOutlined.displayName = 'AlipayOutlined';
export default React.forwardRef(AlipayOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AlipayOutlined.js
// module id = 547
// module chunks = 0